<template>
  <modal-closable :title="title" @close="close" :isOpen="isOpen">
    <div><slot /></div>
    <div slot="footer">
      <button class="button" @click="close">{{ $t("Cancel") }}</button>
      <button v-focus="isOpen" class="button is-danger" @click="confirm">
        {{ confirmText }}
      </button>
    </div>
  </modal-closable>
</template>

<script>
import { ModalClosable } from "@/components/modal"

export default {
  name: "modal-confirmation",
  props: ["title", "confirmText", "isOpen"],
  components: { ModalClosable },
  methods: {
    close() {
      this.$emit("close")
      this.$emit("update:isOpen", false)
    },
    confirm() {
      this.$emit("confirm")
    }
  }
}
</script>
